/**
 * InfoTip — TZ 2026-09-23 Блок 2: hover-тултипы к настройкам админки.
 *
 * Маленький «i» рядом с лейблом; при hover/focus — подпись по-человечески
 * («Температура 0.3 — строго и однообразно; 0.7 — живее, но может
 * фантазировать»). Никаких зависимостей: подсказка — абсолютный блок,
 * который показывается на group-hover (в т.ч. с клавиатуры — focus-visible).
 * Текст задаётся вызывающим через t(...) — i18n parity в локалях.
 */
import { useState } from 'react';

import { cn } from '@/lib/utils';

export function InfoTip({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <span
      className={cn(
        'relative inline-flex items-center align-middle group/tip',
        className,
      )}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label={text}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        className="flex items-center cursor-help text-surface-500 hover:text-primary-400 transition-colors"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-3 h-3"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-10.75a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM9.25 9a.75.75 0 011.5 0v3.5a.75.75 0 01-1.5 0V9z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute z-40 bottom-full left-1/2 -translate-x-1/2 mb-1.5
                     w-56 sm:w-64 max-w-[80vw] px-2.5 py-2 rounded-lg text-xs
                     leading-snug font-normal normal-case tracking-normal
                     bg-surface-900 border border-surface-700 text-surface-200
                     shadow-md pointer-events-none whitespace-normal text-left"
        >
          {text}
        </span>
      )}
    </span>
  );
}